import { loadingStore } from 'mobx-loading';
import getProviderFunc from '@/utils/getProvider';
import Account from './account';
import Ui from './ui';
import Ticker from './ticker';
import Futures from './futures';
import Asset from './asset';
import Home from './home';
import Finance from './finance';

import Position from './position';
import Order from './order';
import Entrust from './entrust';
import Takeover from './takeover';
import Notice from './notice';
import StepRate from './stepRate';
import Activity from './activity';
import UnderlyingIns, { Underlying } from './underlying';
import Otc from './otc';
import Spot from './spot';
import SpotAsset from './spotAsset';
import SpotEntrust from './spotEntrust';
import SpotOrder from './spotOrder';
import SpotPosition from './spotPosition';
import SpotTicker from './spotTicker';
import Coin from './coin';
import AccountAsset from './accountAsset'; // 用户资产信息
import OtcConsumer from './otcConsumer';
import Follow from './follow';

class RootStore {
  account: Account;

  ticker: Ticker;

  futures: Futures;

  loading: { actions: { [key: string]: boolean } };

  underlying: Underlying;

  ui: Ui;

  asset: Asset;

  home: Home;

  position: Position;

  order: Order;

  entrust: Entrust;

  takeover: Takeover;

  notice: Notice;

  stepRate: StepRate;

  activity: Activity;

  otc: Otc;

  spot: Spot;

  spotAsset: SpotAsset;

  spotEntrust: SpotEntrust;

  spotPosition: SpotPosition;

  spotOrder: SpotOrder;

  spotTicker: SpotTicker;

  coin: Coin;

  accountAsset: AccountAsset;

  otcConsumer: OtcConsumer;
  follow: Follow;
  finance: Finance;

  constructor() {
    this.account = new Account();
    this.ticker = new Ticker();
    this.futures = new Futures(this);
    this.loading = loadingStore;
    this.underlying = UnderlyingIns;
    this.ui = new Ui();
    this.asset = new Asset();
    this.home = new Home();

    this.position = new Position();
    this.order = new Order();
    this.entrust = new Entrust();
    this.takeover = new Takeover();
    this.notice = new Notice();
    this.stepRate = new StepRate();
    this.activity = new Activity();
    this.otc = new Otc();
    this.spot = new Spot(this);
    this.spotEntrust = new SpotEntrust();
    this.spotAsset = new SpotAsset();
    this.spotOrder = new SpotOrder();
    this.spotPosition = new SpotPosition();
    this.spotTicker = new SpotTicker();
    this.coin = new Coin();
    this.accountAsset = new AccountAsset(this);
    this.otcConsumer = new OtcConsumer();
    this.finance = new Finance();
    this.follow=new Follow()
  }
}

const stores = new RootStore();

export default stores;

export const { Provider, useStore } = getProviderFunc<typeof stores>();
